"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReactMentionsFormat = void 0;
var getReactMentionsFormat = function (display, id) {
    return "{{internalmention:".concat(id, ",").concat(display, "}}");
};
exports.getReactMentionsFormat = getReactMentionsFormat;
